export const MODULE_NAME = '@pressreader/content';
